<template>
    <div
        class="relative min-h-[34.884vw] overflow-hidden rounded-lg border border-grey-300 xs:min-h-[150px]"
    >
        <img
            :src="item.imageLable"
            class="absolute right-0 top-4"
            alt="background"
            onerror="this.style.display='none'"
        />
        <div class="absolute inset-[2px] flex items-end rounded-[8px]">
            <img
                class="absolute right-0 z-10 h-full rounded-[8px] object-contain"
                :src="item.imageMobile"
                :alt="item.title"
            />
            <div class="absolute bottom-[18px] left-[10px] z-20 xs:left-[25px]">
                <img class="h-[56px] w-[56px]" :src="item.logo" />
                <p
                    class="max-w-[130px] text-center text-[4.651vw] font-semibold uppercase xs:max-w-[150px] xs:text-xl"
                >
                    {{ item.title }}
                </p>
            </div>
        </div>
        <img
            v-if="item?.label === 'hot'"
            class="absolute left-0 top-0 h-auto w-10 rounded-tl-[8px]"
            :src="`${staticUrl}/assets/icons/hot.png`"
            alt="hot icon"
        />
        <img
            v-if="item?.label === 'new'"
            class="absolute left-0 top-0 h-auto w-10 rounded-tl-[8px]"
            :src="`${staticUrl}/assets/icons/new.png`"
            alt="new icon"
        />
    </div>
</template>

<script setup>
// eslint-disable-next-line vue/require-prop-types
const { item } = defineProps(['item'])
const staticUrl = useRuntimeConfig().public.staticUrl
</script>
